import React from 'react';

import { Button, Image, Tooltip } from 'antd';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  padding: 0;
  border: 0;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px var(--line-gray);

  &&.ant-btn > span {
    display: flex;
  }

  &&.ant-btn[disabled],
  &&.ant-btn:disabled {
    cursor: default; /* arrow pointer */
  }
`;

type Props = {
  isMultipleSelection: boolean;
  toggleMultipleSelection: () => void;
  disabled: boolean;
  dataTestId?: string;
};

const CompanyGatedMultiSelectButton = ({
  isMultipleSelection,
  toggleMultipleSelection,
  disabled,
  dataTestId,
}: Props) => {
  const button = (
    <StyledButton
      style={isMultipleSelection ? { borderColor: 'var(--button-blue)' } : undefined}
      onClick={toggleMultipleSelection}
      disabled={disabled}
      data-test-id={dataTestId}
    >
      <Image
        src={isMultipleSelection ? '/icons/checklist-selected.svg' : '/icons/checklist.svg'}
        width={24}
        height={24}
        preview={false}
      />
    </StyledButton>
  );

  if (!disabled) {
    return button;
  }

  return (
    <Tooltip title="Filter by company to enable multi select">
      <span>{button}</span>
    </Tooltip>
  );
};

export default CompanyGatedMultiSelectButton;
